import { render, staticRenderFns } from "./CampaignActionsEdit.vue?vue&type=template&id=2107561f&lang=pug&"
import script from "./CampaignActionsEdit.vue?vue&type=script&lang=js&"
export * from "./CampaignActionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CampaignActionsEdit.vue?vue&type=style&index=0&id=2107561f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports